import axios from "axios";
import {
  CreateCustomFormFieldRequest,
  CustomFormField,
  SearchFormFieldsPayload,
  SearchFormFieldsResponse,
  UpdateCustomFormFieldRequest,
} from "src/types/settings/customFormFields";

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const baseApi = `${cleverstoryApiUrl}/api/2.0/custom_fields`;

export const customFormFieldsApi = {
  searchFormFields: async (payload: SearchFormFieldsPayload): Promise<SearchFormFieldsResponse> => {
    const response = await axios.post(`${baseApi}/forms/search`, payload);
    return response.data;
  },

  fetchFormFieldDetail: async (id: string): Promise<CustomFormField> => {
    const response = await axios.get(`${baseApi}/${id}?storyboard=`);
    return response.data;
  },

  createFormField: async (data: CreateCustomFormFieldRequest): Promise<CustomFormField> => {
    const response = await axios.post(`${baseApi}?storyboard=`, data);
    return response.data;
  },

  updateFormField: async (id: string, data: UpdateCustomFormFieldRequest): Promise<CustomFormField> => {
    const response = await axios.put(`${baseApi}/${id}?storyboard=`, data);
    return response.data;
  },

  deleteFormField: async (id: string): Promise<void> => {
    await axios.delete(`${baseApi}/${id}?storyboard=`);
  },
};
